// extracted by mini-css-extract-plugin
module.exports = {"container":"Historic_container__2E59e","content":"Historic_content__uPeUl"};